<script>
import Confirmation from '@/components/widgets/modals/Confirmation'
import { channelMap, numChannelMap } from './lib/vssconfiguration'

export default {
  name: 'FormDeviceProfile',
  components: { Confirmation },
  props: {
    modal: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    initialData: { type: Object, default: null },
    deviceTypeOptions: { type: Array, default: null },
  },
  data() {
    return {
      modalConfirm: false,
      modalUnsavedConfirm: false,
      linkageModal: false,
      activeAlarmType: null, // 'dms' or 'adas'
      activeRowIndex: null,
      originalFormData: null,
      linkageForm: {
        start_record: 1,
        voice_broadcast: 1,
        preview_mode: 'Model2',
        video_lock: [],
        video_upload: [],
        link_output: false,
        snapshot_upload: [],
        out1_output_time: 10,
        preview: [],
      },
      previewModeOptions: [
        { id: 'Model0', name: 'Model1' },
        { id: 'Model1', name: 'Model2' },
        { id: 'Model2', name: 'Model3' },
        { id: 'Model3', name: 'Model4' },
      ],
      form: {
        id: null,
        profileName: '',
        deviceType: null,
        action: null,
        // DMS Settings
        dms: {
          videoChannel: 'CH3',
          installation: 'default',
          iManualSet: 0,
          draw_en: 0,
          pitch_down: 10,
          pitch_up: 15,
          yaw_left: 5,
          yaw_right: 5,
          installSelfCheck: 0, // 1 (for enable)
          alarms: [
            { key: 'call', type: 'Call', state: 0, threshold: 15, interval: 30, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'smoking', type: 'Smoking', state: 0, threshold: 15, interval: 30, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'eyes_closed', type: 'Eyes closed', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'close_eys_serious', type: 'Severe Eye Closure', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'yawning', type: 'Yawning', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'yawn_serious', type: 'Severe Yawning', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'distracted', type: 'Distracted Driving', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'no_driver', type: 'No driver', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'infrared', type: 'Infrared blocking sunglasses', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'seat_belt', type: 'Seat belt not fastened', state: 0, threshold: 0, interval: 0, pre_record: 0, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'camera_cover', type: 'Camera Cover', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'fatigue_driving', type: 'Fatigue Driving', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
          ],
          other: {
            horizonPixel: 334,
            centerlinePixel: 634,
          },
        },
        // ADAS Settings
        adas: {
          videoChannel: 'CH2',
          draw_en: 0,
          installSelfCheck: 0, // 1 (for enable)
          alarms: [
            { key: 'fcw', type: 'Forward collision warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
            { key: 'hmw', type: 'Headway monitoring warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
            { key: 'ldw', type: 'Lane departure warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
            { key: 'pcw', type: 'Pedestrian collision warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
          ],
          calibration: {
            cameraHeight: 0,
            cameraToBumper: 0,
            cameraToCenterline: 0,
            cameraToAxle: 0,
            vehicleWidth: 0,
            bottomExtraWidth: 0,
            brakeTime: 0,
            iCameraToLeftWheel: 0,
          },
          other: {
            horizonPixel: 334,
            centerlinePixel: 634,
          },
        },
      },
      actionOptions: [
        { id: 'ADAS', name: 'ADAS' },
        { id: 'DMS', name: 'DMS' },
      ],
      channelOptions: Array.from({ length: 12 }, (_, i) => ({
        id: `CH${i + 1}`,
        name: `CH${i + 1}`,
      })),
      stateOptions: [
        { id: 1, name: 'Enable' },
        { id: 0, name: 'Close' },
      ],
      installSelfCheckOptions: [
        { id: 1, name: 'Enable' },
        { id: 0, name: 'Disable' },
      ],
      sensitivityOptions: [
        { id: 0, name: 'High' },
        { id: 1, name: 'Middle' },
        { id: 2, name: 'Low' },
      ],
      oddDeviceType: [12004, 12006],
      installOptions: [
        { id: 'default', name: 'Default' },
        { id: 'left', name: 'Left' },
        { id: 'right', name: 'Right' },
      ],
      angleOptions: [
        { id: 0, name: 'Manual' },
        { id: 2, name: 'Value calibrated during installation' },
      ],
      aiFrameOptions: [
        { id: 0, name: 'Close' },
        { id: 1, name: 'Enable' },
      ],
      dmsFields: [
        { key: 'type', label: 'Type' },
        { key: 'state', label: 'State' },
        { key: 'threshold', label: 'Threshold (s)' },
        { key: 'interval', label: 'Interval (s)' },
        { key: 'pre_record', label: 'Alarm pre-recording (s)' },
        { key: 'alarm_trigger', label: 'Alarm trigger hold time' },
        { key: 'keeptime', label: 'Duty Cycle' },
        { key: 'alarm_linkage', label: 'Alarm Linkage' },
      ],
      adasFields: [
        { key: 'type', label: 'Type' },
        { key: 'state', label: 'State' },
        { key: 'speed', label: 'Speed (km/h)' },
        { key: 'interval', label: 'Interval (s)' },
        { key: 'pre_record', label: 'Alarm pre-recording (s)' },
        { key: 'sensitivity', label: 'Sensitivity' },
        { key: 'alarm_linkage', label: 'Alarm Linkage' },
      ],
    }
  },
  computed: {
    showModal: {
      get() { return this.modal },
      set(v) { this.$emit('update:modal', v) }
    },
    loading: {
      get() { return this.isLoading },
      set(v) { this.$emit('update:isLoading', v) }
    },
    isEdit() {
      return !!this.form.id
    },
    showDmsSettings() {
      return this.form.action === 'DMS'
    },
    showAdasSettings() {
      return this.form.action === 'ADAS'
    },
  },
  watch: {
    modal(newVal) {
      if (newVal) {
        this.initForm()
      }
    },
    initialData: {
      handler() {
        if (this.modal) this.initForm()
      },
      deep: true,
    },
  },
  methods: {
    hasUnsavedChanges() {
      if (!this.originalFormData) return false
      return JSON.stringify(this.form) !== JSON.stringify(this.originalFormData)
    },
    closeModalWithoutSaving() {
      this.modalUnsavedConfirm = false
      this.$emit('update:modal', false)
    },
    saveAndCloseModal() {
      this.modalUnsavedConfirm = false
      this.openConfirm()
    },
    transformFromApi(apiData) {
      const numberToChannel = (num) => {
        return numChannelMap[num] || 'CH1'
      }

      const maskToChannels = (mask = 0) => {
        const channels = []

        Object.entries(channelMap).forEach(([ch, value]) => {
          if (mask & value) {
            channels.push(ch)
          }
        })

        return channels
      }

      const codeToPreviewMode = (code) => {
        return `Model${Number(code)}`
      }

      const installationMap = { 0: 'default', 1: 'left', 2: 'right' }

      if (apiData.type === 'dms') {
        const alarmTypeMap = {
          call: 'call',
          smoke: 'smoking',
          close_eyes: 'eyes_closed',
          close_eys_serious: 'close_eys_serious',
          yawn: 'yawning',
          yawn_serious: 'yawn_serious',
          distract_driving: 'distracted',
          driver_abnormal: 'no_driver',
          ir_blocking: 'infrared',
          seatbelt_unfastened: 'seat_belt',
          lens_covered: 'camera_cover',
          fatigue_driving: 'fatigue_driving',
        }

        const alarmNameMap = {
          call: 'Call',
          smoke: 'Smoking',
          close_eyes: 'Eyes closed',
          close_eys_serious: 'Severe Eye Closure',
          yawn: 'Yawning',
          yawn_serious: 'Severe Yawning',
          distract_driving: 'Distracted Driving',
          driver_abnormal: 'No driver',
          ir_blocking: 'Infrared blocking sunglasses',
          seatbelt_unfastened: 'Seat belt not fastened',
          lens_covered: 'Camera Cover',
          fatigue_driving: 'Fatigue Driving',
        }

        const alarms = (apiData.alarm_settings || []).map((alarm) => {
          const formKey =
            Object.keys(alarmTypeMap).find((k) => alarmTypeMap[k] === alarm.type) || alarm.type

          return {
            key: formKey,
            type: alarmNameMap[formKey] || alarm.type,
            state: alarm.state,
            threshold: alarm.threshold,
            interval: alarm.interval,
            pre_record: alarm.alm_triger_pre_recording,
            alarm_trigger: alarm.alm_triger_hold_time,
            keeptime: alarm.coefficient || alarm.keeptime,
            linkage: {
              start_record: alarm.record,
              voice_broadcast: alarm.link_buzzer,
              preview_mode: codeToPreviewMode(alarm.link_preview_mode),
              video_lock: maskToChannels(alarm.link_lock_chn),
              video_upload: maskToChannels(alarm.link_video_upload_chn),
              link_output: alarm.link_output === 1,
              snapshot_upload: maskToChannels(alarm.link_snap_chn),
              out1_output_time: alarm.out1_time ?? 10,
              preview: maskToChannels(alarm.link_preview_chn),
            },
          }
        })

        return {
          id: apiData.id,
          profileName: apiData.profile_name,
          deviceType: apiData.device_code,
          action: 'DMS',
          dms: {
            iManualSet: apiData.i_manual_set,
            videoChannel: numberToChannel(apiData.chn),
            installation: installationMap[apiData.installation] || 'default',
            yaw_right: apiData.yaw_right ?? 0,
            yaw_left: apiData.yaw_left ?? 0,
            pitch_down: apiData.pitch_down ?? 0,
            pitch_up: apiData.pitch_up ?? 0,
            draw_en: apiData.draw_en ?? 0,
            installSelfCheck: apiData.install_self_check ?? 0,
            alarms: alarms,
          },
          adas: this.form.adas,
        }
      } else if (apiData.type === 'adas') {
        const alarmNameMap = {
          fcw: 'Forward collision warning',
          hmw: 'Headway monitoring warning',
          ldw: 'Lane departure warning',
          pcw: 'Pedestrian collision warning',
        }

        const alarms = (apiData.alarm_settings || []).map((alarm) => {
          const formKey = alarm.type

          let sensitivity = alarm.sensitivity

          return {
            key: formKey,
            type: alarmNameMap[formKey] || alarm.type,
            state: alarm.state,
            speed: alarm.speed,
            interval: alarm.interval,
            pre_record: alarm.alm_triger_pre_recording,
            alarm_trigger: alarm.alm_triger_hold_time,
            sensitivity: sensitivity,
            linkage: {
              start_record: alarm.record,
              voice_broadcast: alarm.link_buzzer,
              preview_mode: codeToPreviewMode(alarm.link_preview_mode),
              video_lock: maskToChannels(alarm.link_lock_chn),
              video_upload: maskToChannels(alarm.link_video_upload_chn),
              link_output: alarm.link_output === 1,
              snapshot_upload: maskToChannels(alarm.link_snap_chn),
              out1_output_time: alarm.out1_time ?? 10,
              preview: maskToChannels(alarm.link_preview_chn),
            },
          }
        })

        return {
          id: apiData.id,
          profileName: apiData.profile_name,
          deviceType: apiData.device_code,
          action: 'ADAS',
          dms: this.form.dms, // Keep default DMS structure
          adas: {
            videoChannel: numberToChannel(apiData.chn),
            draw_en: apiData.draw_en ?? 0,
            installSelfCheck: apiData.install_self_check ?? 0,
            alarms: alarms,
            calibration: {
              cameraHeight: apiData.cam_height || 0,
              cameraToBumper: apiData.cam_to_bumper || 0,
              cameraToCenterline: apiData.cam_to_center || 0,
              cameraToAxle: apiData.cam_to_axle || 0,
              vehicleWidth: apiData.vehicle_width || 0,
              bottomExtraWidth: apiData.bottom_extra_width || 0,
              brakeTime: apiData.brake_time || 0,
              iCameraToLeftWheel: apiData.i_camera_to_left_wheel || 0,
            },
            other: {
              horizonPixel: apiData.horizon_line ?? 334,
              centerlinePixel: apiData.centerline ?? 634,
            },
          },
        }
      }

      return null
    },

    initForm() {
      if (this.initialData) {
        if (this.initialData.alarm_settings) {
          const transformed = this.transformFromApi(this.initialData)
          if (transformed) {
            this.form = transformed
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.initialData))
        }

        this.originalFormData = JSON.parse(JSON.stringify(this.form))
      } else {
        this.resetForm()
        this.originalFormData = null
      }
    },
    resetForm() {
      this.form = {
        id: null,
        profileName: '',
        deviceType: null,
        action: null,
        dms: {
          videoChannel: 'CH3',
          installation: 'default',
          iManualSet: 0,
          yaw_right: 0,
          yaw_left: 0,
          pitch_down: 0,
          pitch_up: 0,
          draw_en: 0,
          installSelfCheck: 0,
          alarms: [
            { key: 'call', type: 'Call', state: 0, threshold: 15, interval: 30, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'smoking', type: 'Smoking', state: 0, threshold: 15, interval: 30, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'eyes_closed', type: 'Eyes closed', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'close_eys_serious', type: 'Severe Eye Closure', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'yawning', type: 'Yawning', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'yawn_serious', type: 'Severe Yawning', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'distracted', type: 'Distracted Driving', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'no_driver', type: 'No driver', state: 0, threshold: 15, interval: 10, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'infrared', type: 'Infrared blocking sunglasses', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'seat_belt', type: 'Seat belt not fastened', state: 0, threshold: 0, interval: 0, pre_record: 0, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'camera_cover', type: 'Camera Cover', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
            { key: 'fatigue_driving', type: 'Fatigue Driving', state: 0, threshold: 15, interval: 60, pre_record: 5, alarm_trigger: 0.5, keeptime: 50, linkage: null },
          ],
        },
        adas: {
          videoChannel: 'CH2',
          draw_en: 0,
          installSelfCheck: 0,
          alarms: [
            { key: 'fcw', type: 'Forward collision warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
            { key: 'hmw', type: 'Headway monitoring warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
            { key: 'ldw', type: 'Lane departure warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
            { key: 'pcw', type: 'Pedestrian collision warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, linkage: null },
          ],
          calibration: {
            cameraHeight: 0,
            cameraToBumper: 0,
            cameraToCenterline: 0,
            cameraToAxle: 0,
            vehicleWidth: 0,
            bottomExtraWidth: 0,
            brakeTime: 0,
            iCameraToLeftWheel: 0,
          },
          other: {
            horizonPixel: 334,
            centerlinePixel: 634,
          },
        },
      }
    },
    closeModal() {
      if (this.hasUnsavedChanges()) {
        this.modalUnsavedConfirm = true
      } else {
        this.$emit('update:modal', false)
      }
    },
    openConfirm() {
      if (!this.form.profileName || !this.form.deviceType || !this.form.action) {
        this.$toast.error('Fill required field')
        return
      }

      if (this.isEdit && this.originalFormData) {
        const hasChanges = this.detectChanges()
        if (!hasChanges) {
          this.$toast.info('No changes detected')
          this.closeModal()
          return
        }
      }

      this.modalConfirm = true
    },
    detectChanges() {
      return JSON.stringify(this.originalFormData) !== JSON.stringify(this.form)
    },
    getChangedFields() {
      if (!this.originalFormData) return null

      const changes = []

      const transformField = (key) => {
        if (key === 'iManualSet') {
          return 'distraction_angle'
        }
        if (key === 'draw_en') {
          return 'ai_frame'
        }
        if (key === 'yaw_left') {
          return 'driving angle Left'
        }
        if (key === 'yaw_right') {
          return 'driving angle Right'
        }
        if (key === 'pitch_up') {
          return 'driving angle Upper'
        }
        if (key === 'pitch_down') {
          return 'driving angle Down'
        }
        return key
      }
      
      const formatValue = (value, fieldName) => {
        if (fieldName === 'state') {
          const option = this.stateOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'sensitivity' && !this.oddDeviceType.includes(this.form.deviceType)) {
          const option = this.sensitivityOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'installation') {
          const option = this.installOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'iManualSet') {
          const option = this.angleOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'draw_en') {
          const option = this.aiFrameOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'start_record') {
          const option = this.stateOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'voice_broadcast') {
          const option = this.stateOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'preview_mode') {
          const option = this.previewModeOptions.find(o => o.id === value)
          return option ? option.name : value
        }
        if (fieldName === 'videoChannel') {
          return value
        }
        if (Array.isArray(value)) {
          return value.sort().join(',')
        }
        return value
      }
      
      const compareObjects = (original, current, path = '') => {
        for (const key in current) {
          const currentPath = path ? `${path}.${key}` : key
          
          if (typeof current[key] === 'object' && current[key] !== null && !Array.isArray(current[key])) {
            if (original[key]) {
              compareObjects(original[key], current[key], currentPath)
            }
          } else if (Array.isArray(current[key])) {
            if (JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
              const maxLength = Math.max(original[key]?.length || 0, current[key].length)
              for (let i = 0; i < maxLength; i++) {
                const origItem = original[key]?.[i]
                const currItem = current[key][i]
                
                if (typeof currItem === 'object' && currItem !== null) {
                  for (const prop in currItem) {
                    if (prop === 'type' || prop === 'key') continue
                    
                    // Handle nested objects like linkage
                    if (typeof currItem[prop] === 'object' && currItem[prop] !== null && !Array.isArray(currItem[prop])) {
                      const origNested = origItem?.[prop]
                      const currNested = currItem[prop]
                      
                      if (JSON.stringify(origNested) !== JSON.stringify(currNested)) {
                        // Compare each nested property
                        for (const nestedKey in currNested) {
                          if (JSON.stringify(origNested?.[nestedKey]) !== JSON.stringify(currNested[nestedKey])) {
                            const fieldPath = `${currItem.key}.${prop}.${nestedKey}`
                            changes.push({
                              field: fieldPath,
                              before: formatValue(origNested?.[nestedKey], nestedKey)?.toString(),
                              after: formatValue(currNested[nestedKey], nestedKey)?.toString()
                            })
                          }
                        }
                      }
                    } else if (JSON.stringify(origItem?.[prop]) !== JSON.stringify(currItem[prop])) {
                      const fieldPath = `${currItem.key}.${prop}`
                      changes.push({
                        field: fieldPath,
                        before: formatValue(origItem?.[prop], prop)?.toString(),
                        after: formatValue(currItem[prop], prop)?.toString()
                      })
                    }
                  }
                }
              }
            }
          } else if (JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
            // Value has changed
            changes.push({
              field: transformField(key),
              before: formatValue(original[key], key),
              after: formatValue(current[key], key)
            })
          }
        }
      }

      compareObjects(this.originalFormData, this.form)
      return changes
    },
    afterConfirm() {
      const changedFields = this.isEdit ? this.getChangedFields() : null
      const deviceTypeField = changedFields?.find((c) => c.field === "deviceType")

      if (deviceTypeField) {
        const { before, after } = deviceTypeField
        this.form.changes = changedFields.map((c) =>
          c.field !== "deviceType" ? c : {
            field: "deviceType",
            before: this.deviceTypeOptions.find((dt) => dt.id === before)?.name,
            after: this.deviceTypeOptions.find((dt) => dt.id === after)?.name
          }
        )
      } else {
        this.form.changes = changedFields
      }
      this.form.adas.alarms = this.form?.adas?.alarms.map((alarm) => {
        return {...alarm, sensitivity: Number(alarm.sensitivity)}
      })

      this.$emit('submit', this.form)
      this.modalConfirm = false
    },
    onlyNumber(evt) {
      const c = String.fromCharCode(evt.which)
      if (!/[0-9]/.test(c)) evt.preventDefault()
    },
    openLinkage(item, index, type) {
      this.activeAlarmType = type
      this.activeRowIndex = index
      const saved = item.linkage || {}
      this.linkageForm = {
        start_record: saved.start_record ?? 1,
        voice_broadcast: saved.voice_broadcast ?? 1,
        preview_mode: saved.preview_mode ?? 'Model2',
        video_lock: Array.isArray(saved.video_lock) ? [...saved.video_lock] : [],
        video_upload: Array.isArray(saved.video_upload) ? [...saved.video_upload] : [],
        link_output: saved.link_output ?? false,
        snapshot_upload: Array.isArray(saved.snapshot_upload) ? [...saved.snapshot_upload] : [],
        out1_output_time: saved.out1_output_time ?? 10,
        preview: Array.isArray(saved.preview) ? [...saved.preview] : [],
      }
      this.linkageModal = true
    },
    saveLinkage() {
      if (this.activeRowIndex !== null && this.activeAlarmType) {
        const alarms = this.activeAlarmType === 'dms' ? this.form.dms.alarms : this.form.adas.alarms
        const row = alarms[this.activeRowIndex]
        row.linkage = JSON.parse(JSON.stringify(this.linkageForm))
      }
      this.linkageModal = false
    },
    validateRange(value, min, max) {
      if (value === null || value === undefined || value === '') return null
      return value >= min && value <= max
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      :title="isEdit ? 'Edit Device Profile' : 'Create Device Profile'"
      size="xl"
      centered
      :hide-header-close="true"
      no-close-on-backdrop
      hide-footer
    >
      <div class="card-body mc-modal__filter p-2">
        <b-form @submit.stop.prevent>
          <div class="mb-3">
            <h6 class="mb-3 text-primary">Profile Information</h6>
            <b-row>
              <b-col cols="12" md="4" class="mb-2">
                <label>Profile Name <span class="text-danger">*</span></label>
                <b-form-input v-model="form.profileName" placeholder="Enter profile name" />
              </b-col>
              <b-col cols="12" md="4" class="mb-2">
                <label>Device Type <span class="text-danger">*</span></label>
                <v-select
                  v-model="form.deviceType"
                  :options="deviceTypeOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  placeholder="Select device type"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="4" class="mb-2">
                <label>Action <span class="text-danger">*</span></label>
                <v-select
                  v-model="form.action"
                  :options="actionOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  placeholder="Select action"
                  :clearable="false"
                />
              </b-col>
            </b-row>
          </div>

          <div v-if="showDmsSettings" class="mb-3">
            <h6 class="mb-3 text-primary">DMS Settings</h6>
            <b-row class="mb-2">
              <b-col cols="12" md="3" class="mb-2">
                <label>Video Channel</label>
                <v-select
                  v-model="form.dms.videoChannel"
                  :options="channelOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>Installation</label>
                <v-select
                  v-model="form.dms.installation"
                  :options="installOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>Distraction angle setting</label>
                <v-select
                  v-model="form.dms.iManualSet"
                  :options="angleOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>AI frame</label>
                <v-select
                  v-model="form.dms.draw_en"
                  :options="aiFrameOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>Install self check</label>
                <v-select
                  v-model="form.dms.installSelfCheck"
                  :options="installSelfCheckOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
            </b-row>

            <b-row v-if="form.dms.iManualSet !== 2" class="mb-2">
              <b-col cols="12" md="3" class="mb-2">
                <label>Distracted driving angle Right</label>
                <b-form-input
                  v-model.number="form.dms.yaw_right"
                  type="number"
                  min="0"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>Distracted driving angle Left</label>
                <b-form-input
                  v-model.number="form.dms.yaw_left"
                  type="number"
                  min="0"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>Distracted driving angle Lower</label>
                <b-form-input
                  v-model.number="form.dms.pitch_down"
                  type="number"
                  min="0"
                />
              </b-col>
              <b-col cols="12" md="3" class="mb-2">
                <label>Distracted driving angle Upper</label>
                <b-form-input
                  v-model.number="form.dms.pitch_up"
                  type="number"
                  min="0"
                />
              </b-col>
            </b-row>

            <div class="table-responsive border border-1">
              <b-table small :items="form.dms.alarms" :fields="dmsFields" head-variant="light">
                <template #cell(type)="{ item }">
                  <strong>{{ item.type }}</strong>
                </template>
                <template #cell(state)="{ item }">
                  <v-select
                    v-model="item.state"
                    :options="stateOptions"
                    label="name"
                    :reduce="(v) => v.id"
                    :clearable="false"
                  />
                </template>
                <template #cell(threshold)="{ item }">
                  <b-form-input
                    v-model.number="item.threshold"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(interval)="{ item }">
                  <b-form-input
                    v-model.number="item.interval"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(pre_record)="{ item }">
                  <b-form-input
                    v-model.number="item.pre_record"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(alarm_trigger)="{ item }">
                  <b-form-input
                    v-model.number="item.alarm_trigger"
                    type="number"
                    step="0.1"
                    min="0"
                  />
                </template>
                <template #cell(keeptime)="{ item }">
                  <b-form-input
                    v-model.number="item.keeptime"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(alarm_linkage)="{ item, index }">
                  <b-button @click="openLinkage(item, index, 'dms')" size="sm" variant="primary">
                    Alarm linkage
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>

          <div v-if="showAdasSettings" class="mb-3">
            <h6 class="mb-3 text-primary">ADAS Settings</h6>
            <b-row class="mb-2">
              <b-col cols="12" md="4" class="mb-2">
                <label>Video Channel</label>
                <v-select
                  v-model="form.adas.videoChannel"
                  :options="channelOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="4" class="mb-2">
                <label>AI frame</label>
                <v-select
                  v-model="form.adas.draw_en"
                  :options="aiFrameOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
              <b-col cols="12" md="4" class="mb-2">
                <label>Install self check</label>
                <v-select
                  v-model="form.adas.installSelfCheck"
                  :options="installSelfCheckOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
            </b-row>

            <div class="table-responsive border border-1 mb-3">
              <b-table small :items="form.adas.alarms" :fields="adasFields" head-variant="light">
                <template #cell(type)="{ item }">
                  <strong>{{ item.type }}</strong>
                </template>
                <template #cell(state)="{ item }">
                  <v-select
                    v-model="item.state"
                    :options="stateOptions"
                    label="name"
                    :reduce="(v) => v.id"
                    :clearable="false"
                  />
                </template>
                <template #cell(speed)="{ item }">
                  <b-form-input
                    v-model.number="item.speed"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(interval)="{ item }">
                  <b-form-input
                    v-model.number="item.interval"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(pre_record)="{ item }">
                  <b-form-input
                    v-model.number="item.pre_record"
                    type="number"
                    min="0"
                    @keypress="onlyNumber"
                  />
                </template>
                <template #cell(sensitivity)="{ item }">
                  <v-select
                    v-if="!oddDeviceType.includes(form.deviceType)"
                    v-model="item.sensitivity"
                    :options="sensitivityOptions"
                    label="name"
                    :reduce="(v) => v.id"
                    :clearable="false"
                  />
                  <b-form-input
                    v-else
                    v-model="item.sensitivity"
                    type="text"
                    inputmode="decimal"
                  />
                </template>
                <template #cell(alarm_linkage)="{ item, index }">
                  <b-button @click="openLinkage(item, index, 'adas')" size="sm" variant="primary">
                    Alarm linkage
                  </b-button>
                </template>
              </b-table>
            </div>

            <h6 class="mb-3">ADAS Calibration</h6>
            <b-row>
              <b-col cols="12" md="6" class="mb-2">
                <label>Camera Height (cm)</label>
                <b-form-input
                  v-model.number="form.adas.calibration.cameraHeight"
                  type="number"
                  min="0"
                  disabled
                  @keypress="onlyNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Camera to Bumper (cm)</label>
                <b-form-input
                  v-model.number="form.adas.calibration.cameraToBumper"
                  type="number"
                  min="0"
                  disabled
                  @keypress="onlyNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Camera to Centerline (cm)</label>
                <b-form-input
                  v-model.number="form.adas.calibration.cameraToCenterline"
                  type="number"
                  min="0"
                  disabled
                  @keypress="onlyNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Camera to Axle (cm)</label>
                <b-form-input
                  v-model.number="form.adas.calibration.cameraToAxle"
                  type="number"
                  min="0"
                  disabled
                  @keypress="onlyNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Vehicle Width (cm)</label>
                <b-form-input
                  v-model.number="form.adas.calibration.vehicleWidth"
                  type="number"
                  min="0"
                  disabled
                  @keypress="onlyNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Bottom Extra Width</label>
                <b-form-input
                  v-model.number="form.adas.calibration.bottomExtraWidth"
                  type="number"
                  step="0.001"
                  min="0"
                  disabled
                  :max="oddDeviceType.includes(form.deviceType) ? 5 : undefined"
                  :state="oddDeviceType.includes(form.deviceType) ? validateRange(form.adas.calibration.bottomExtraWidth, 0, 5) : null"
                />
                <b-form-invalid-feedback v-if="oddDeviceType.includes(form.deviceType)" :state="validateRange(form.adas.calibration.bottomExtraWidth, 0, 5)">
                  Bottom Extra Width must be between 0 and 5
                </b-form-invalid-feedback>
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Brake Time</label>
                <b-form-input
                  v-model.number="form.adas.calibration.brakeTime"
                  type="number"
                  step="0.001"
                  min="0"
                  disabled
                  :max="oddDeviceType.includes(form.deviceType) ? 2.5 : undefined"
                  :state="oddDeviceType.includes(form.deviceType) ? validateRange(form.adas.calibration.brakeTime, 0, 2.5) : null"
                />
                <b-form-invalid-feedback v-if="oddDeviceType.includes(form.deviceType)" :state="validateRange(form.adas.calibration.brakeTime, 0, 2.5)">
                  Brake Time must be between 0 and 2.5
                </b-form-invalid-feedback>
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Camera to Left Wheel (cm)</label>
                <b-form-input
                  v-model.number="form.adas.calibration.iCameraToLeftWheel"
                  type="number"
                  min="0"
                  disabled
                  @keypress="onlyNumber"
                />
              </b-col>
            </b-row>

            <hr class="my-3" />
            <h6 class="mb-3">Other Settings</h6>
            <b-row>
              <b-col cols="12" md="6" class="mb-2">
                <label>Horizon (pixel)</label>
                <b-form-input
                  v-model.number="form.adas.other.horizonPixel"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <label>Centerline (pixel)</label>
                <b-form-input
                  v-model.number="form.adas.other.centerlinePixel"
                  type="number"
                  :max="oddDeviceType.includes(form.deviceType) ? 60 : undefined"
                  :min="oddDeviceType.includes(form.deviceType) ? -60 : 0"
                  @keypress="!oddDeviceType.includes(form.deviceType) ? onlyNumber : null"
                  :state="oddDeviceType.includes(form.deviceType) ? validateRange(form.adas.other.centerlinePixel, -60, 60) : null"
                />
                <b-form-invalid-feedback v-if="oddDeviceType.includes(form.deviceType)" :state="validateRange(form.adas.other.centerlinePixel, -60, 60)">
                  Centerline must be between -60 and 60
                </b-form-invalid-feedback>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </div>

      <template>
        <div class="ms-2 d-flex justify-content-end align-items-center">
          <b-button variant="outline-primary" @click="closeModal" :disabled="loading" class="me-3">
            Cancel
          </b-button>
          <b-button @click="openConfirm" variant="primary" :disabled="loading">
            <b-spinner v-if="loading" small type="grow"></b-spinner>
            {{ loading ? 'Loading...' : 'Save' }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <confirmation
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      :message="
        isEdit
          ? 'Are you sure you want to update this profile?'
          : 'Are you sure you want to create this profile?'
      "
      @confirmed="afterConfirm"
      centered
    />

    <b-modal
      v-model="modalUnsavedConfirm"
      class="mc-modal"
      title="Confirmation"
      centered
      hide-footer
    >
      <p>Changes have not been saved. Do you want to save the changes?</p>
      <div class="text-end">
        <b-button variant="outline-secondary" @click="closeModalWithoutSaving" class="me-3">
          Close without saving
        </b-button>
        <b-button variant="primary" @click="saveAndCloseModal">
          Save
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="linkageModal"
      class="mc-modal"
      id="modal-alarm-linkage"
      title="Alarm linkage"
      size="xl"
      centered
      hide-footer
    >
      <div class="card-body p-2">
        <b-row>
          <b-col cols="12" md="6">
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Start record</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.start_record"
                  :options="stateOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Preview mode</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.preview_mode"
                  :options="previewModeOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Video Upload</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-for="ch in channelOptions"
                    :key="'up-' + ch.id"
                    v-model="linkageForm.video_upload"
                    :value="ch.id"
                    class="me-2"
                  >
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Out1 output time</b-col>
              <b-col cols="7">
                <b-form-input 
                  v-model.number="linkageForm.out1_output_time"
                  @keypress="onlyNumber"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Preview</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-for="ch in channelOptions"
                    :key="'prev-' + ch.id"
                    v-model="linkageForm.preview"
                    :value="ch.id"
                    class="me-2"
                  >
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Voice broadcast</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.voice_broadcast"
                  :options="stateOptions"
                  label="name"
                  :reduce="(v) => v.id"
                  :clearable="false"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Video lock</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-for="ch in channelOptions"
                    :key="'lock-' + ch.id"
                    v-model="linkageForm.video_lock"
                    :value="ch.id"
                    class="me-2"
                  >
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Link output</b-col>
              <b-col cols="7" class="d-flex">
                <b-form-checkbox v-model="linkageForm.link_output">
                  <label class="ms-1">OUT1</label>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Snapshot and Upload</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-for="ch in channelOptions"
                    :key="'snap-' + ch.id"
                    v-model="linkageForm.snapshot_upload"
                    :value="ch.id"
                    class="me-2"
                  >
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="text-end mt-3">
          <b-button variant="primary" @click="saveLinkage">Close</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
